import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const NotificationTextUploadPage = ({ uploadPage, url, linkText }) => {
  const intl = useIntl();

  const text = linkText || (uploadPage.title || intl.formatMessage({ defaultMessage: '(deleted upload page)' }));

  return (
    <>
      {uploadPage.title && intl.formatMessage({ defaultMessage: 'guest upload page' })}{' '}
      {uploadPage.uuid ? (
        <a href={url ? url.split('#')[0] : `/u/${uploadPage.url}`} target="_blank" rel="noreferrer">
          <strong>{text || ''}</strong>
        </a>
      ) : (
        <strong>{text || ''}</strong>
      )}
    </>
  );
};

NotificationTextUploadPage.propTypes = {
  uploadPage: PropTypes.object,
  url: PropTypes.string,
  linkText: PropTypes.string,
};

NotificationTextUploadPage.defaultProps = {
  uploadPage: {
    title: '',
  },
  url: null,
  linkText: null,
};

export default NotificationTextUploadPage;
